import React, { useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { Dropdown } from 'shared/ui/dropdown';
import { SeeAllHeader } from 'shared/ui/layout';
import { RecommendationsContent } from 'widgets/recommendations/ui/recommendations-content/recommendations-content';
import { useRecommendations } from 'widgets/recommendations/model';
import { ALL_SUBJECTS } from 'features/filters';
import {
  eventService,
  generateCommonContextEventPayload,
  generateProductFilterResultEventPayload,
  getPage,
  XApiEventKeys,
} from 'shared/api/event-service';

import styles from './styles.module.scss';

export const AllRecommendations = () => {
  const { t } = useTranslation();

  const { recommendations, isLoading } = useRecommendations();
  const [filteredDomain, setFilteredDomain] = useState<string | undefined>(
    undefined,
  );

  const uniqueRecommendationDomains = [
    ...new Set(
      recommendations.flatMap(({ content: { productNames, productName } }) =>
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/prefer-nullish-coalescing
        productNames ? Object.values(productNames) : productName || '',
      ),
    ),
  ]
    .filter(Boolean)
    .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

  const handleXApiEvents = (subjects: string[], isRightClick: boolean) => {
    const productFilterIsAll = subjects[0] === ALL_SUBJECTS;
    const productFiltersApplied = productFilterIsAll
      ? uniqueRecommendationDomains
      : subjects;

    eventService.send(
      XApiEventKeys.productFiltered,
      generateProductFilterResultEventPayload({
        productFilterIsAll,
        productFiltersApplied,
      }),
      generateCommonContextEventPayload({
        url: window.location.href,
        page: getPage(),
        isRightClick,
      }),
    );
  };

  const handleSelect = (subject: string, _: string, eventType?: string) => {
    handleXApiEvents([subject], eventType === 'contextmenu');

    if (subject === ALL_SUBJECTS) {
      setFilteredDomain(undefined);
      return;
    }
    setFilteredDomain(subject);
  };

  return (
    <>
      <SeeAllHeader title={t('Recommendations')}>
        <Dropdown
          classNames={{
            button: styles['subjectButton'],
            container: styles['subjectPicker'],
            menu: styles['subjectMenu'],
          }}
          onSelect={handleSelect}
          isLoading={false}
          customDropdownText={'All Subjects'}
        >
          {uniqueRecommendationDomains.length > 1 && (
            <Dropdown.Item id={ALL_SUBJECTS}>{t('All Subjects')}</Dropdown.Item>
          )}
          {uniqueRecommendationDomains.map((subject) => (
            <Dropdown.Item key={subject} id={subject}>
              {subject}
            </Dropdown.Item>
          ))}
        </Dropdown>
      </SeeAllHeader>
      <div className={clsx(styles.itemGrid, 'col-lg-9 col-sm-12')}>
        <RecommendationsContent
          filteredDomain={filteredDomain}
          recommendations={recommendations}
          isLoading={isLoading}
        />
      </div>
    </>
  );
};
